/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createAtan } from '../../factoriesAny.js';
export var atanDependencies = {
  typedDependencies,
  createAtan
};